import Config from "cortex-config";
import PropTypes from "prop-types";
import React from "react";
import GoogleAnalytics from "react-ga";

GoogleAnalytics.initialize(Config.GOOGLE_ANALYTICS_ID);

function withTracker(TargetComponent, options = {}) {
  const trackPage = (page) => {
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  const wrapped = class extends React.Component {
    static displayName() {
      return "GoogleAnalyticsWrapped";
    }

    static get propTypes() {
      return {
        location: PropTypes.object,
      };
    }

    componentDidMount() {
      trackPage(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
      const nextPage = this.props.location.pathname;
      const currentPage = prevProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(currentPage);
      }
    }

    render() {
      return <TargetComponent {...this.props} />;
    }
  };

  return wrapped;
}

export { withTracker };
